export const trimWithEllipsis = (text: string, limit: number): string => {
    if ((text.length + 3) - limit >= 3) {
        return `${text.slice(0, limit)}...`;
    }
    return text;
}